import { useContext } from 'react';
import { getFilteredScoringResult, getRulesScoringResult } from 'src/processes/CMS/processes/management/utils/end-user-flow-helpers';
import { PreviewContext } from 'src/processes/CMS/processes/management/pages/PreviewPage/PreviewContext';
import { useVariables } from 'src/processes/CMS/processes/management/pages/PreviewPage/hooks/useVariables';
import { getHvmQuestionnaireResult, HVM_MESSAGE_VERSION } from '../hvm/questionnaire-result';
import { getHvmTargetOrigins } from '../hvm/target-origin';

function getHvmProductsInfo(pagesFlow) {
  // scoring
  const { answersScoring, rulesProductsProperties, allPages } = pagesFlow;

  const allProductsPages = allPages
    .flatMap(item => {
      return item.elements;
    })
    .filter(el => el.templateType === 'PRODUCT');

  const products = allProductsPages.flatMap(productPage => productPage.content.products);

  const scoringResult = getFilteredScoringResult(answersScoring, pagesFlow, false, products);
  const scoringRulesResult = getRulesScoringResult(products, scoringResult, rulesProductsProperties, false);

  const finalScoring =
    scoringRulesResult
      .map(scoringItem => ({
        hvmProductId: scoringItem.hvmProductId,
        score: (scoringItem.score || 0) + (scoringItem.ruleScore || 0),
      }))
      .filter(scoringItem => scoringItem.hvmProductId) || [];

  const productsWithHvmId = products.filter(product => product.hvmProductId !== null);

  const hvmRecommended = JSON.parse(localStorage.getItem('hvmRecommended')) || [];

  return productsWithHvmId.map(product => ({
    score: finalScoring.find(scoringItem => scoringItem.hvmProductId === product.hvmProductId)?.score,
    selected: product.selected,
    hvmProductId: product.hvmProductId,
    recommended: hvmRecommended.includes(product.hvmProductId),
    counter: product.counterSection?.value,
    showCounter: product.counterSection?.showCounter,
  }));
}

export function useHvmIntegration(pagesFlow) {
  // The admin constructor renders the buttons outside the preview, without the context.
  const { pageHistory = [] } = useContext(PreviewContext) || {};
  const { applyVariable } = useVariables(pagesFlow);

  const sendHvmData = () => {
    // we're on admin constructor page
    if (!pagesFlow?.allPages) {
      return;
    }

    const message = {
      messageType: 'hvm',
      version: HVM_MESSAGE_VERSION,
      products: getHvmProductsInfo(pagesFlow),
      questionnaire: getHvmQuestionnaireResult({ pagesFlow, pageHistory, applyText: applyVariable }),
    };

    for (const targetOrigin of getHvmTargetOrigins()) {
      window.parent.postMessage(message, targetOrigin);
    }
  };

  return { sendHvmData };
}
